import { Flex, Form, Select } from 'antd'
import { FC, ReactNode, useMemo } from 'react'
import { useGetMaterialGroupsQuery } from '../../../store/api/material-groups-api'
import { EndpointQueryParameters } from '../../../types/strapi/strapi'
import { SelectProps } from 'antd/lib'
import { NamePath } from 'antd/es/form/interface'
import { Rule } from 'antd/es/form'
import { requiredOneElementRules } from '../../../constants/forms/validation/rules'
import formatNumber from '../../../helpers/formatters/format-any-number'

interface MaterialTypesGroupedProps {
    noStyle?: boolean
    rules?: Rule[]
    mode?: SelectProps['mode']
    name?: NamePath
    onBlur?: () => void
    autoFocus?: boolean
    defaultOpen?: boolean
    disabled?: boolean
    label?: ReactNode
    purchaserDocumentId?: string
}

const MaterialTypesGrouped: FC<MaterialTypesGroupedProps> = ({
    noStyle,
    mode,
    rules = requiredOneElementRules,
    name = 'materialTypes',
    onBlur,
    autoFocus,
    defaultOpen,
    disabled,
    label,
    purchaserDocumentId,
}) => {
    const queryParams = useMemo<EndpointQueryParameters>(
        () => ({
            fields: ['name'],
            populate: {
                material_types: {
                    fields: ['name', 'cost'],
                    ...(purchaserDocumentId
                        ? {
                              filters: {
                                  purchaser: { documentId: { $eq: purchaserDocumentId } },
                              },
                          }
                        : {}),
                },
            },
        }),
        [purchaserDocumentId]
    )
    const { data } = useGetMaterialGroupsQuery(queryParams)
    const materialGroups = (data?.data || []).filter(group =>
        purchaserDocumentId ? (group.material_types?.length ?? 0) > 0 : true
    )

    return (
        <Form.Item
            name={name}
            rules={rules}
            noStyle={noStyle}
            label={label}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
        >
            <Select
                style={{ width: '100%' }}
                mode={mode}
                showSearch
                optionLabelProp='label'
                filterOption={(input, option) => {
                    const label = option?.label
                    if (typeof label !== 'string') return false
                    return label.toLowerCase().includes(input.toLowerCase())
                }}
                allowClear
                placeholder='Материал'
                popupMatchSelectWidth={500}
                onBlur={onBlur}
                autoFocus={autoFocus}
                defaultOpen={defaultOpen}
                disabled={disabled}
            >
                {materialGroups.map(group => (
                    <Select.OptGroup key={group.id} label={group.name}>
                        {group.material_types?.map(type => (
                            <Select.Option key={type.id} value={type.documentId} label={type.name}>
                                <Flex justify='space-between' gap={12} style={{ width: '100%' }}>
                                    <span>{type.name}</span>
                                    {type.cost != null ? (
                                        <span>{formatNumber(type.cost)}</span>
                                    ) : null}
                                </Flex>
                            </Select.Option>
                        ))}
                    </Select.OptGroup>
                ))}
            </Select>
        </Form.Item>
    )
}

export default MaterialTypesGrouped
